import {
  Box,
  Text,
  Flex,
  Step,
  StepDescription,
  StepIcon,
  StepIndicator,
  StepNumber,
  StepSeparator,
  StepStatus,
  StepTitle,
  Stepper,
  useSteps,
  Image,
  Button,
} from "@chakra-ui/react";
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import GiftIcon from "../../assets/GiftIcon.png";
import {
  getOrderById,
  getUserAddressById,
} from "../../Redux/ProductController/action";
import { Link } from "react-router-dom";
import moment from "moment";
import { useNavigate } from "react-router-dom";

import { getOrderHistory } from "../../Redux/App/action";
import axios from "axios";

let BASE_URL_FLORAHUB;
if (process.env.NODE_ENV === "production") {
  BASE_URL_FLORAHUB = process.env.REACT_APP_API_URL_FLORAHUB;
} else {
  BASE_URL_FLORAHUB = process.env.REACT_APP_API_URL_FLORAHUB;
}

const OrderDetails = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const accessToken = localStorage.getItem("token");
  const OrderId = localStorage.getItem("orderId");
  const { orderDataById, userAddressDataById } = useSelector(
    (store) => store.prodReducer
  );

  const [shipmentStatus, setShipmentStatus] = useState([]);

  useEffect(() => {
    const handleBackButton = (event) => {
      event.preventDefault();
      // Redirect to the current page or any other page
      navigate("/");
    };

    window.history.pushState(null, null, window.location.pathname);
    window.addEventListener("popstate", handleBackButton);

    return () => {
      window.removeEventListener("popstate", handleBackButton);
    };
  }, [navigate]);

  useEffect(() => {
    dispatch(getOrderById(OrderId));
    dispatch(getOrderHistory);
  }, [dispatch, OrderId]);

  useEffect(() => {
    if (orderDataById && orderDataById?.addressId) {
      const id = orderDataById.addressId;
      dispatch(getUserAddressById(id));
    }
  }, [dispatch, orderDataById]);

  const totalAmount = orderDataById.netOrderAmountResponse?.totalPayAmount || 0;
  const deliveryFee = orderDataById?.netOrderAmountResponse?.deliveryFee;
  const orderPlacedOn = orderDataById?.payload?.createdAt;
  const formattedDate = moment(orderPlacedOn).format("dddd, MMM Do YY");
  const deliveredDate = moment(orderPlacedOn)
    .add(5, "days")
    .format("dddd, MMM Do YY");

  const orderId = localStorage.getItem("orderId");
  async function getShipmentStatus(orderId) {
    try {
      const response = await axios.get(
        `${BASE_URL_FLORAHUB}/shipment/api/v2/track/shipment?orderId=${orderId}`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data) {
        setShipmentStatus(response.data.payload);
      }
    } catch (error) {
      if (error.response && error.response.status === 400) {
        console.log("400 Error");
      } else {
        console.log("something went wrong ", error);
      }
    }
  }

  useEffect(() => {
    getShipmentStatus(orderId);
  }, [orderId]);

  const { activeStep, setActiveStep } = useSteps({
    index: 0,
    count: shipmentStatus?.length || 0,
  });

  useEffect(() => {
    if (shipmentStatus.length > 0) {
      const index = shipmentStatus.filter(
        (status) => status.trackingDate !== null
      ).length;
      setActiveStep(index);
    }
  }, [shipmentStatus, setActiveStep]);

  const handleOrderId = () => {
    localStorage.removeItem("orderId");
  };

  return (
    <Box>
      <Box
        mb={"10"}
        ml={{ base: "0", md: "10", lg: "10" }}
        textAlign={{ base: "center", md: "left", lg: "left" }}
      >
        <Text
          fontWeight="bold"
          fontSize="28px"
          lineHeight="41px"
          letterSpacing="0"
          color="#3C375F"
          mt={"5"}
        >
          Order Details
        </Text>
      </Box>

      {/* Order Place For Rs. */}
      <Box>
        <Flex
          flexDirection={{ base: "column", md: "row", lg: "row" }}
          justifyContent={{ base: "center", md: "space-between" }}
          alignItems={{ base: "center", md: "space-between" }}
          mx={{ base: "0", md: "14" }}
        >
          <Flex>
            <Image src={GiftIcon} h={"85px"} />
            <Box mb={{ base: "10" }}>
              <Text
                mt={"8"}
                textAlign="left"
                fontWeight="bold"
                fontSize="18px"
                lineHeight="20px"
                fontFamily="Lato"
                letterSpacing="0"
                color="#200E32"
                opacity="1"
              >
                Order Placed For Rs. {totalAmount}
              </Text>
              <Text
                left="177px"
                fontFamily="Lato"
                fontSize={{ base: "10px", md: "14px", lg: "16px" }}
                color="#AFAFAF"
              >
                Expected Delivery Date, 4-5 Days
              </Text>
            </Box>
          </Flex>

          <Box
            border="1px solid #707070"
            background="#FFFFFF"
            backgroundRepeat="no-repeat"
            boxShadow="2px 5px 10px rgba(0, 0, 0, 0.29)"
            opacity="1"
            borderRadius={"10"}
            width={{ base: "80%", md: "30%" }}
          >
            <Flex
              flexDirection={{ base: "column", md: "row", lg: "row" }}
              justifyContent={"space-between"}
            >
              <Box width={{ md: "100%", lg: "100%" }} margin={"auto"}>
                <Text
                  width="100%"
                  mt={"5"}
                  fontFamily="Lato"
                  fontWeight="bold"
                  mb={"2"}
                  fontSize="16px"
                  lineHeight="16px"
                  letterSpacing="0px"
                  textAlign="center"
                  color="#4F4F4F"
                  opacity="1"
                >
                  We Have Many More Amazing Product
                </Text>
                <Link to={"/"}>
                  <Button
                    mt={"2"}
                    fontWeight="semibold"
                    fontSize={{ base: "15px", md: "16px" }}
                    letterSpacing="0px"
                    color="white"
                    bgColor="#3b82f6"
                    opacity="1"
                    _hover={{
                      color: "black",
                      bgColor: "#E4DEDE",
                    }}
                    mb={"5"}
                    onClick={handleOrderId}
                  >
                    Continue Shopping
                  </Button>
                </Link>
              </Box>
            </Flex>
          </Box>
        </Flex>
      </Box>

      {/* Order Details Section*/}
      <Box
        w={{ base: "90%", md: "90%", lg: "90%" }}
        margin={"auto"}
        mt={"10"}
        background={"#F7F7F7"}
        borderRadius={"10"}
        px={"5"}
        py={"2"}
      >
        <Flex
          justifyContent={"space-between"}
          flexDirection={{ base: "column", md: "column", lg: "row" }}
        >
          <Box
            w={{ base: "100%", md: "100%", lg: "20%" }}
            textAlign={"left"}
            mb={{ base: "10" }}
          >
            <Flex flexDirection={"column"}>
              <Box>
                <Text
                  fontFamily={"Lato"}
                  mb={"5"}
                  fontSize={"14px"}
                  textAlign={"left"}
                >
                  <strong>Order On:</strong> {formattedDate}
                  <br />
                  <strong>Order ID:</strong> {OrderId}
                </Text>
              </Box>
              {/* <Box>
                <Flex flexDirection={"column"}>
                  <Button
                    h={"30px"}
                    border="1px solid #6FADDC"
                    background="#FFFFFF"
                    backgroundRepeat="no-repeat"
                    boxShadow="0px 3px 6px rgba(0, 0, 0, 0.29)"
                    borderRadius="10px"
                    opacity="1"
                    fontSize={"12px"}
                    color={"#1B8CEB"}
                    mb={"2"}
                  >
                    {" "}
                    Contact Wishfy
                  </Button>
                </Flex>
              </Box> */}
            </Flex>
          </Box>
          <Box
            w={{ base: "100%", md: "100%", lg: "20%" }}
            textAlign={"left"}
            mb={{ base: "10" }}
          >
            {" "}
            <Text
              fontFamily="Lato"
              fontWeight="bold"
              fontSize="20px"
              lineHeight="24px"
              letterSpacing="0px"
              textAlign="left"
              color="#372449"
              opacity="1"
            >
              Delivery Address
            </Text>
            <Text
              mt={"2"}
              fontFamily="Lato"
              fontWeight="normal"
              fontSize="14px"
              lineHeight="24px"
              letterSpacing="0px"
              textAlign="left"
              color="#3E3E3E"
              opacity="1"
            >
              {userAddressDataById.addressUnit}, {userAddressDataById.locality},{" "}
              {userAddressDataById.landmark}
              <br />
              {userAddressDataById.city}, {userAddressDataById.state} -{" "}
              {userAddressDataById.pincode} <br />
              Contact Person - {userAddressDataById.contactPersonName} <br />
              Contact No. - {userAddressDataById.contactNo}
            </Text>
          </Box>
          <Box
            w={{ base: "100%", md: "100%", lg: "20%" }}
            textAlign={"left"}
            mb={{ base: "10" }}
          >
            {" "}
            <Text
              fontFamily="Lato"
              fontWeight="bold"
              fontSize="20px"
              lineHeight="24px"
              letterSpacing="0px"
              textAlign="left"
              color="#372449"
              opacity="1"
            >
              Payment Method
            </Text>
            <Text
              fontFamily="Lato"
              fontWeight="normal"
              fontSize="14px"
              lineHeight="24px"
              letterSpacing="0px"
              textAlign="left"
              color="#3E3E3E"
              opacity="1"
              mt={"2"}
            >
              Cash On Delivery
            </Text>
          </Box>
          <Box
            w={{ base: "100%", md: "100%", lg: "20%" }}
            textAlign={"left"}
            mb={{ base: "10" }}
          >
            {" "}
            <Text
              fontFamily="Lato"
              fontWeight="bold"
              fontSize="20px"
              lineHeight="24px"
              letterSpacing="0px"
              textAlign="left"
              color="#372449"
              opacity="1"
            >
              Order Summary
            </Text>
            <Box width="100%" opacity="1">
              <Flex justifyContent={"space-between"}>
                <Box mt={2} width={"50%"}>
                  <Text
                    width="100%"
                    height="100%"
                    fontFamily="Lato, Sans serif"
                    fontWeight="Regular"
                    fontSize="14px"
                    lineHeight="24px"
                    letterSpacing="0px"
                    textAlign={"left"}
                    color="#06211A"
                  >
                    Item(s) Subtotal: <br />
                    Discount Amount: <br />
                    Wallet Amount: <br />
                    Delivery Fee: <br />
                    Grand Total:
                  </Text>
                </Box>
                <Box mt={2}>
                  <Text
                    textAlign={"left"}
                    width="100%"
                    height="100%"
                    fontFamily="Lato, sans serif"
                    fontWeight="bold"
                    fontSize="16px"
                    lineHeight="24px"
                    letterSpacing="0px"
                    color="#06211A"
                  >
                    ₹{orderDataById.netOrderAmountResponse?.itemTotalAmount}
                    <br />₹
                    {orderDataById.netOrderAmountResponse?.discountAmount}
                    <br />₹
                    {
                      orderDataById.netOrderAmountResponse
                        ?.applicableWalletAmount
                    }
                    <br />₹{deliveryFee}
                    <br />₹ {totalAmount}
                    <br />
                  </Text>
                </Box>
              </Flex>
            </Box>
          </Box>
        </Flex>
      </Box>

      {/* <Box
        w={"90%"}
        margin={"auto"}
        mt={"10"}
        mb={"10"}
        background={"#F7F7F7"}
        borderRadius={"10"}
        px={"5"}
        py={"2"}
      >
        <OrderSummary data={orderDataById} />
      </Box> */}

      {/* Order Tracking Section*/}
      <Box
        w={"90%"}
        margin={"auto"}
        mt={"10"}
        mb={"10"}
        background={"#F7F7F7"}
        borderRadius={"10"}
        px={"5"}
        py={"2"}
      >
        <Box width={"100%"} overflowX={"auto"} p={5}>
          <Text
            textAlign={"left"}
            mb={5}
            fontWeight="bold"
            fontSize="18px"
            fontFamily="Lato"
            letterSpacing="0"
            color="#200E32"
          >
            Delivery Status
          </Text>
          <Box background={"#F7F7F7"} borderRadius={"10"}>
            <Stepper
              index={activeStep}
              size={{ base: "sm" }}
              margin="auto"
              w={{ base: "100%", md: "60%", lg: "80%" }}
            >
              {shipmentStatus.map((step, index) => (
                <Step key={index}>
                  <StepIndicator>
                    <StepStatus
                      complete={<StepIcon />}
                      incomplete={<StepNumber />}
                      active={<StepNumber />}
                    />
                  </StepIndicator>
                  <Box flexShrink="0">
                    <StepTitle>
                      {step.trackingStatus.replaceAll("_", " ")}
                    </StepTitle>
                    <div>
                      {step.trackingDate ? (
                        <p>{moment(step.trackingDate).format("D MMM, YYYY")}</p>
                      ) : (
                        ""
                      )}
                    </div>
                    <StepDescription>
                      {step.trackingDescription}
                    </StepDescription>
                  </Box>

                  <StepSeparator />
                </Step>
              ))}
            </Stepper>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default OrderDetails;
